import clsx from 'clsx';
import Button from 'components/UI/V3/Button/Button';
import { FunctionComponent } from 'react';
import styles from './Footer.module.scss';

interface FooterProps {
    disabled?: boolean;
    className?: string;
    onApply?: () => void;
}

export const Footer: FunctionComponent<FooterProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <Button
                label="Apply"
                fullWidth={true}
                variant="green"
                disabled={props.disabled}
                onClick={props.onApply}
            />
        </div>
    );
};

export default Footer;
